const Density = {
  LOW: 0,
  OK: 1,
  HIGH: 2
};

const DensityColors = {
    [Density.LOW]: '#e67e22',
    [Density.OK]: '#6eaa34',
    [Density.HIGH]: '#EA5455',
};

const DensityLangPaths = {
  [Density.LOW]: 'low',
  [Density.OK]: 'ok',
  [Density.HIGH]: 'high',
};

export { Density, DensityColors, DensityLangPaths };
